import graphqlClient from '~/graphql/graphqlClient';
import {
  MutationSpawnCavernsMobArgs,
  SpawnCavernsMobResult,
} from 'dt-common/generated/graphql-types';

const mutation = `
mutation SpawnCavernsMob(
  $playerId: String!
  $game_submode: String!
) {
  spawnCavernsMob(playerId: $playerId, game_submode: $game_submode) {
    mob
  }
}`;

export default async function mutationSpawnCavernsMob(args: MutationSpawnCavernsMobArgs) {
  return await graphqlClient.request<SpawnCavernsMobResult>('spawnCavernsMob', mutation, args);
}
